var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAddContact2 = function SvgAddContact2(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M255.501.499C174.053.499 107.79 66.763 107.79 148.21c0 50.449 25.429 95.065 64.137 121.724-36.139 12.471-69.263 33.071-97.091 60.899C26.577 379.093 0 443.254 0 511.501h39.922c0-118.871 96.708-215.579 215.579-215.579 81.448 0 147.711-66.264 147.711-147.712S336.949.499 255.501.499zm0 255.501c-59.435 0-107.789-48.354-107.789-107.789s48.354-107.79 107.789-107.79S363.29 88.775 363.29 148.211 314.936 256 255.501 256zM428.164 387.743v-83.837h-39.922v83.837h-83.837v39.922h83.837v83.836h39.922v-83.836H512v-39.922z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAddContact2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/addContact2.7b540a2d.svg";
export { ForwardRef as ReactComponent };